import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import ExtendResult from '../../components/extend-result/index';
import { getYearGroups } from '../../containers/school-roll/actions';
import {
    closeFailureModal,
    extendResults,
    onProceedExtendResultRequest,
    onCloseExtendResultError,
    setIdsToExtend,
    onShowExtendResultInfo,
    onVerifyExtendResultInfoRequest
} from './actions';

class ExtendResultContainer extends Component {
    constructor(props) {
        super(props);

        const { product } = props;
        props.onVerifyExtendResultInfoRequest(product.id);
    }

    componentDidMount() {
        this.props.getYearGroups();
    }

    render() {
        return (<ExtendResult {...this.props} />);
    }
}

ExtendResultContainer.propTypes = {
    getYearGroups: PropTypes.func,
    onVerifyExtendResultInfoRequest: PropTypes.func,
    product: PropTypes.object
};

const mapStateToProps = state => ({
    extendResultInfo: state.extendResult.extendResultInfo,
    extendResultForm: state.extendResult.extendResultForm,
    isExtending: state.extendResult.isExtending,
    showExtendInfoError: state.extendResult.showExtendInfoError,
    resultsAlreadyExtended: state.extendResult.resultsAlreadyExtended,
    outOfExtendPeriod: state.extendResult.outOfExtendPeriod,
    rollOverRequired: state.extendResult.rollOverRequired,
    currentAcademicYear: state.extendResult.currentAcademicYear,
    extendingResultsStatusType: state.extendResult.extendingResultsStatusType,
    isFail: state.extendResult.isFail,
    isSuccess: state.extendResult.isSuccess,
    yearGroupsToBeExtended: state.extendResult.yearGroupsToBeExtended,
    showOkButton: state.extendResult.showOkButton,
    yearGroups: state.schoolRoll.yearGroups,
    product: state.product
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeFailureModal,
        extendResults,
        getYearGroups,
        onProceedExtendResultRequest,
        onCloseExtendResultError,
        setIdsToExtend,
        onVerifyExtendResultInfoRequest,
        onShowExtendResultInfo
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ExtendResultContainer));



// WEBPACK FOOTER //
// ./app/containers/extend-result/index.js